<template>
  <select class="custom-select" :value="value" @input="$emit('input', $event.target.value)">
    <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
    <option v-for="option in options" :value="option.value" :key="option.value">
      {{ option.text }}
    </option>
  </select>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UeSelect',
  props: {
    value: {
      type: String,
    },
    options: {
      type: Array as PropType<{ value: string; text: string }[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
    },
  },
})
</script>
